/**
 * Shared density tokens for mapping workspace UI.
 *
 * Extends the scope-editor density scale so the attribute table,
 * section editors, and inspector stay visually consistent.
 */

import { scopeEditorDensity } from './ScopeEditorPrimitives';

export const mappingDensity = {
  ...scopeEditorDensity,
  /** Height for a comfortable mapping table row (regular density). */
  tableRowHeight: 40,
  /** Height for a compact mapping table row (laptop). */
  tableRowCompactHeight: 32,
  /** Height for a narrow mapping table row (mobile). */
  tableRowNarrowHeight: 30,
  /** Default height for filter/header inputs in the mapping table. */
  tableInputHeight: 32,
  /** Compact height for filter/header inputs. */
  tableInputCompactHeight: 28,
  /** Narrow height for filter/header inputs. */
  tableInputNarrowHeight: 26,
  /** Height of the workspace toolbar. */
  toolbarHeight: 32,
  /** Height of a small status chip inside the table/inspector. */
  statusChipHeight: 20,
  /** Font size for table body cells. */
  tableCellFontSize: '0.6875rem',
  /** Font size for table header labels. */
  tableHeaderFontSize: '0.625rem',
  /** Font size for inspector body text. */
  inspectorBodyFontSize: '0.75rem',
  /** Font size for inspector caption/overline text. */
  inspectorCaptionFontSize: '0.625rem',
} as const;
